import {
  GET_POST_NOTE_QUALITY_EXPERIMENT_VARIANT,
  IS_POST_NOTE_QUALITY_EXPERIMENT_ASSIGNED,
} from '@/components/constants/flags';
import { useQueryUser } from '@/hooks/query/useQueryUser';

import { areAllImproveNotesTasksComplete } from '../improve-notes-panel/tasks.config';

/**
 * GRO-3284: whether the gamified trial experience may be shown for this user,
 * given their post-note quality experiment arm.
 *
 * - not enrolled / `control`: allowed (today's behaviour).
 * - `sidebar_only` (Arm B): never — the gamified trial is suppressed.
 * - `sequential` (Arm C): allowed only once all coaching-sidebar tasks are
 *   complete, so the gamified trial is introduced after the sidebar.
 *
 * Consumed by every gamified-trial entry point (sidebar button, modal mount,
 * upgrade-modal "Extend trial" CTAs) so the suppression/gating is consistent.
 */
export function useIsGamifyTrialArmAllowed(): boolean {
  const { data: userData } = useQueryUser();

  if (!IS_POST_NOTE_QUALITY_EXPERIMENT_ASSIGNED()) return true;

  const variant = GET_POST_NOTE_QUALITY_EXPERIMENT_VARIANT();
  if (variant === 'control') return true;
  if (variant === 'sidebar_only') return false;

  return areAllImproveNotesTasksComplete(userData?.post_note_quality_completed_tasks);
}
